<template>
  <el-form
    v-loading="loadingAccount"
    label-width="auto"
    size="small"
  >
    <el-form-item
      label="Enter a closing note for this event:"
      :show-message="!note.$fields.content.valid"
      :error="note.$fields.content.message"
      required
    >
      <el-input
        v-model="note.content"
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 8}"
        clearable
      />
    </el-form-item>

    <el-form-item
      v-if="!loadingAccount &&
        (event.account.status === 'lead' || event.account.status === 'pending') &&
        event.account.lead instanceof $sdk.account_lead"
      label="Updated Opportunity Status:"
      :show-message="!event.account.lead.$fields.status.valid"
      :error="event.account.lead.$fields.status.message"
      required
    >
      <el-select
        v-model="event.account.lead.status"
        class="w-100"
      >
        <el-option
          v-for="(option, index) in opportunityStatuses"
          :key="index"
          :disabled="index < opportunityStatuses
            .findIndex(status => status.toLowerCase() === event.account.lead.$fields.status.default.toLowerCase())"
          :label="$filters.titleize(option)"
          :value="option"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    note: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loadingAccount: true
    }
  },
  computed: {
    opportunityStatuses () {
      return [
        'lead',
        'working on',
        'awaiting decision',
        'pending',
        'lost',
        'awaiting invoices',
        'data profiling',
        'rates procurement',
        'commercial analysis',
        'presentation',
        'onboarding',
        'hypercare',
        'SOW',
        'on hold'
      ]
    }
  },
  async created () {
    try {
      await this.event.refresh(builder => {
        builder.include = [ 'account.lead' ]
      })
    } catch {
      this.$message.error('Failed to load Account')
    }

    this.loadingAccount = false
  }
}
</script>
